import { CheckOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, Space, Typography } from "antd";
import React, { useState } from "react";
import { LoanRequestKyc, LoanRequest, Customer } from "../helpers/shared-interfaces";
import { LoanRequestKycView } from "./LoanRequestKycView";
import { LoanRequestKycForm } from "./LoanRequestKycForm";

const { Text } = Typography;

interface Props {
  lastKyc: LoanRequestKyc;
  loanRequest: LoanRequest;
  customer: Customer;
  maritalStatuses: any[];
  idTypes: any[];
  onConfirmReview: (kycData: any) => void;
  onCancel: () => void;
  isLoading?: boolean;
  handleFileUploadChange: (field: string, combinedInfo: string) => void;
  handleDelete: (file: any) => void;
}

export const LoanRequestKycReview: React.FC<Props> = ({
  lastKyc,
  loanRequest,
  customer,
  maritalStatuses,
  idTypes,
  onConfirmReview,
  onCancel,
  isLoading = false,
  handleFileUploadChange,
  handleDelete,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleConfirmReview = () => {
    const kycData = {
      loanRequestId: loanRequest.id,
      ...lastKyc,
    };
    onConfirmReview(kycData);
  };

  const handleEditSubmit = (kycData: any) => {
    onConfirmReview(kycData);
  };

  if (isEditing) {
    return (
      <div>
        <Card 
          size="small" 
          style={{ 
            marginBottom: 16, 
            backgroundColor: "#e6f7ff",
            borderColor: "#1890ff"
          }}
        >
          <Space direction="vertical" size={4}>
            <Text strong style={{ color: "#1890ff" }}>
              Editing Previous KYC Information
            </Text>
            <Text type="secondary">
              Update any information that has changed since your last application
            </Text>
          </Space>
        </Card>

        <LoanRequestKycForm
          loanRequest={{
            ...loanRequest,
            loanRequestKyc: lastKyc,
          }}
          maritalStatuses={maritalStatuses}
          idTypes={idTypes}
          onSubmit={handleEditSubmit}
          onCancel={() => setIsEditing(false)}
          isLoading={isLoading}
          customer={customer}
          isEditMode={true}
          handleFileUploadChange={handleFileUploadChange}
          handleDelete={handleDelete}
        />
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <LoanRequestKycView
          loanRequestKyc={lastKyc}
          loanRequestState="review"
          onEdit={undefined}
        />
      </div>

      <Card size="small">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Text type="secondary">
            Is this information still accurate?
          </Text>

          <Space>
            <Button onClick={onCancel}>
              Cancel
            </Button>
            <Button
              icon={<EditOutlined />}
              onClick={() => setIsEditing(true)}
            >
              Edit Information
            </Button>
            <Button
              type="primary"
              icon={<CheckOutlined />}
              onClick={handleConfirmReview}
              loading={isLoading}
            >
              Confirm & Use This Information
            </Button>
          </Space>
        </div>
      </Card>
    </div>
  );
};